/*
 * File: \packages\lib\util.js
 * File Created: 2022-04-06 09:33:14
 * Author: Li Haifeng
 * -----
 * Last Modified: 2023-03-14 10:28:05
 * Modified By: lihf14
 */

const isMission = () => {
  return (
    window.navigator.userAgent.toLocaleUpperCase().indexOf("MIDEACONNECT") > -1
  );
};

const toJson = (value) => {
  if(Object.prototype.toString.call(value) === '[object String]') {
    return JSON.parse(value)
  }
  else if (Object.prototype.toString.call(value) === '[object Object]') {
    return JSON.parse(JSON.stringify(value))
  }
  else {
    return value
  }
}

export default { isMission, toJson }